<!-- eslint-disable -->
<template>
  <CommonPages id="privacy" :class="['privacy-page']" :titlePrefix="pageMetaTitle"
    :metaDescription="pageMetaDescription">
    <LegalContentLayout title="Privacy Policy">
      <div class="legal-richtext">
        <div v-html="privacyBody"></div>
      </div>
    </LegalContentLayout>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'
import LegalContentLayout from '@/components/legal/LegalContentLayout.vue'
import { getContentTextMap, getText, renderTemplate } from '@/utils/contentText';
import { stripLeadingRichTextTitle } from '@/utils/richTextTitle';

import '@/css/common.scss';

const PRIVACY_BODY = 'Privacy Policy<br>We value your privacy. This Privacy Policy outlines our commitment to a data-minimalist approach for our global city rankings.<br><br>1. Information We Do Not Collect<br>This website is designed as a static information resource. As such:<br><br>- No User Accounts: We do not require registration or any personal information (such as names or email addresses) to access our city ratings.<br><br>- No Cookies: We do not use cookies, web beacons, or similar tracking technologies to monitor your browsing behavior or store preferences on your device.<br><br>- No User Content: We do not provide features for uploading comments, photos, or reviews, so no user-generated data is stored on our servers.<br><br>2. Information Automatically Logged<br>Like nearly all web servers, our hosting provider may automatically log basic technical information (such as your IP address, browser type, and the time of your visit) for security purposes and to ensure the website functions correctly. This information is anonymous and is not used to identify individual visitors.<br><br>3. Third-Party Links<br>Our evaluations for the 50 selected cities may contain links to external websites (such as official tourism boards or news sources). We have no control over, and assume no responsibility for, the privacy practices or content of these third-party sites.<br><br>4. Data Security<br>We implement standard security measures to protect the integrity of the information presented on this website. However, because we do not collect personal data from our visitors, there is no personal database at risk of compromise.<br><br>5. Changes to This Policy<br>We reserve the right to modify this Privacy Policy as our website evolves. Any updates will be reflected directly on this page.<br><br>6. Contact<br>If you have any questions regarding our privacy practices, please contact us through the information provided on our website.';

export default {
  name: 'Privacy',
  components: {
    CommonPages,
    LegalContentLayout
  },
  mixins: [common, adMixin, adTrackingMixin],
  computed: {
    ...mapGetters([
      'domainConfig',
    ]),
    contentText () {
      return getContentTextMap(this.domainConfig);
    },
    privacyBody () {
      const template = getText(this.contentText, 'PRIVACY_BODY', PRIVACY_BODY);
      const rendered = renderTemplate(template, {
        SITE_NAME: this.domainConfig?.siteName || 'SITE_NAME',
        CONTACT_EMAIL: this.domainConfig?.IAMEMAIL || this.contentText.CONTACT_EMAIL || 'CONTACT_EMAIL'
      });
      return stripLeadingRichTextTitle(rendered, 'Privacy Policy');
    },
    pageMetaTitle () {
      return getText(this.contentText, 'PRIVACY_META_TITLE', 'Privacy Policy');
    },
    pageMetaDescription () {
      return getText(this.contentText, 'HOME_META_DESCRIPTION', 'Privacy Policy and information about how we use your data');
    }
  },
};
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.legal-richtext {
	display: flex;
	flex-direction: column;
	gap: rem(8);
}
</style>
